export const GET_ASSESSMENT_TEST_DETAILS = "GET_ASSESSMENT_TEST_DETAILS"
export const GET_ASSESSMENT_TEST_DETAILS_SUCCESS="GET_ASSESSMENT_TEST_DETAILS_SUCCESS"
export const GET_ASSESSMENT_TEST_DETAILS_FAILED="GET_ASSESSMENT_TEST_DETAILS_FAILED"
export const FINISH_ASSESSMENT_TEST="FINISH_ASSESSMENT_TEST"
export const FINISH_ASSESSMENT_TEST_SUCCESS="FINISH_ASSESSMENT_TEST_SUCCESS"
export const FINISH_ASSESSMENT_TEST_FAILED="FINISH_ASSESSMENT_TEST_FAILED"
export const GET_ASSESSMENT_TEST_QUESTIONS = "GET_ASSESSMENT_TEST_QUESTIONS"
export const GET_ASSESSMENT_TEST_QUESTIONS_SUCCESS="GET_ASSESSMENT_TEST_QUESTIONS_SUCCESS"
export const GET_ASSESSMENT_TEST_QUESTIONS_FAILED="GET_ASSESSMENT_TEST_QUESTIONS_FAILED"